import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mobile/home/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d430b8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "btnWrap" }

import { ref, computed } from "vue";
import { getLoginVisitor } from "@/api/request/login";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLogin',
  setup(__props) {

function beforeClose(done: any) {
  store.commit("SET_LOGIN_BEFORE", false);
  // done();
}
const dialogVisible = computed(() => {
  return store.state.user.loginBeforeDialog;
});
// function  getDrawerHeight (){
// 	let scale = document.documentElement.clientWidth / 540;
// 	return 675 * scale;
// }
function loginTo() {
  getLoginVisitor().then((res) => {
    if (res.data.token) {
      localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, res.data.token);
      localStorage.setItem(process.env.VUE_APP_VISITOR, res.data.username);
      store.dispatch("GetInfo").then(() => {
        store.commit("SET_LOGIN_BEFORE", false);
        window.location.reload();
      });
    }
  });
}
function tt4bLogin(type?: string) {
  if (type === "employee") {
    store.dispatch("Login", { type });
  } else {
    store.dispatch("Login").catch((err) => {
      console.info("登录异常", err);
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    size: "60%",
    "custom-class": "loginDrawer",
    direction: 'btt',
    "with-header": false,
    lockScroll: false,
    "before-close": beforeClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("选择登录账户继续操作")), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("登录方式")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "btns",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loginTo()))
          }, _toDisplayString(_ctx.$t("游客登录")), 1),
          _createElementVNode("div", {
            class: "btns",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tt4bLogin()))
          }, _toDisplayString(_ctx.$t("TikTok for Business账号登录")), 1),
          _createElementVNode("div", {
            class: "btns",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (tt4bLogin('employee')))
          }, _toDisplayString(_ctx.$t("内部员工登录")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})